import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Language } from '@containers/i18n/store/i18n.interface'

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  constructor(private http: HttpClient) {}

  fetchLanguagesList(params): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/language/list`
    return this.http.post(url, params)
  }

  deleteLanguage(iso2code: string) {
    const url = `${environment.API_ENDPOINT}/admin/language/${iso2code}`
    return this.http.delete(url)
  }

  createLanguage(body: Language) {
    const url = `${environment.API_ENDPOINT}/admin/language`
    return this.http.post(url, body)
  }

  updateLanguage(iso2code: string, body: Language) {
    const url = `${environment.API_ENDPOINT}/admin/language/${iso2code}`
    return this.http.put(url, body)
  }
}
